<template>
  <button class="boton boton--imprimir" @click="imprimir"/>
</template>

<script>
export default {
  methods: {
    imprimir() {
      window.print();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/comunes/PrintBtn.vue